export const heroData = {
  headline: "Building Your Dream Home with Quality & Trust",
  subheadline: "10+ years of excellence in construction across Karnataka",
  ctaText: "Get Free Quote",
  heroImages: [
    "https://images.pexels.com/photos/3034343/pexels-photo-3034343.jpeg",
    "https://images.pexels.com/photos/35116768/pexels-photo-35116768.jpeg",
    "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg"
  ]
};

export const statsData = [
  { label: "Homes Built", value: "25+" },
  { label: "Years of Experience", value: "10+" },
  { label: "Projects Delivered", value: "12+" },
  { label: "Client Satisfaction", value: "100%" }
];

export const trustedBrands = [
  { name: "Ultratech Cement", logo: "/images/brands/ultratech.svg" },
  { name: "JSW Steel", logo: "/images/brands/jsw.svg" },
  { name: "Jaquar", logo: "/images/brands/jaquar.svg" },
  { name: "Asian Paints", logo: "/images/brands/asianpaints.svg" },
  { name: "Hindware", logo: "/images/brands/hindware.svg" },
  { name: "Finolex", logo: "/images/brands/finolex.svg" }
];

export const videoTestimonials = [
  {
    id: 1,
    videoUrl: "https://www.youtube.com/embed/cHbjbcCaosc?si=0QA16Jf_YMj691J3",
    thumbnail: "https://img.youtube.com/vi/cHbjbcCaosc/maxresdefault.jpg"
  },
  {
    id: 2,
    videoUrl: "https://www.youtube.com/embed/RauyFelooOQ?si=-ss6a0XSNXbD8PvX",
    thumbnail: "https://img.youtube.com/vi/RauyFelooOQ/maxresdefault.jpg"
  },
  {
    id: 3,
    videoUrl: "https://www.youtube.com/embed/OqdHQ5SWh38?si=qtcTRv38_qBPU60A",
    thumbnail: "https://img.youtube.com/vi/OqdHQ5SWh38/maxresdefault.jpg"
  },
  {
    id: 4,
    videoUrl: "https://www.youtube.com/embed/ljGbnugXwdI?si=jVq9Ki9oDg15eZHK",
    thumbnail: "https://img.youtube.com/vi/ljGbnugXwdI/maxresdefault.jpg"
  },
  {
    id: 5,
    videoUrl: "https://www.youtube.com/embed/P8BFvNvir8Q?si=1U-O-4iuO1mekngC",
    thumbnail: "https://img.youtube.com/vi/P8BFvNvir8Q/maxresdefault.jpg"
  },
  {
    id: 6,
    videoUrl: "https://www.youtube.com/embed/qvxXLLR0WVA?si=A_Haql_O0icAoZg1",
    thumbnail: "https://img.youtube.com/vi/qvxXLLR0WVA/maxresdefault.jpg"
  }
];

export const whyChooseUs = [
  {
    icon: "Award",
    title: "Creative Innovation",
    description: "Bringing fresh design ideas and modern construction techniques to every project"
  },
  {
    icon: "CheckCircle2",
    title: "Technical Precision",
    description: "Meticulous attention to detail and structural excellence in all deliverables"
  },
  {
    icon: "Users",
    title: "Client-Focused Collaboration",
    description: "Working closely with you at every stage to ensure your vision comes to life"
  },
  {
    icon: "Clock",
    title: "Vision to Reality",
    description: "Turning your dream home from concept to completion with seamless execution"
  }
];

export const processSteps = [
  { step: "01", title: "Consultation", description: "Understanding your requirements, budget, and site conditions" },
  { step: "02", title: "Design & Planning", description: "Detailed architectural plans and structural design" },
  { step: "03", title: "Construction", description: "Quality construction with premium materials and supervision" },
  { step: "04", title: "Handover", description: "Timely delivery of your complete dream home" }
];

export const cities = ["Bangalore", "Mysore", "Tumkur", "Hassan", "Chennai", "Hyderabad"];
